import { OverlayRef } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const CONFIG_MODAL_INPUTS_TOKEN = new InjectionToken<any>('CONFIG_MODAL_INPUTS');

export class ModalOverlayRef {
  constructor(private overlayRef: OverlayRef) { }

  close(): void {
    this.overlayRef.dispose();
  }
}
